var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import APButton from '../../common/APButton';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import { setDropdownsDefaultValue } from '../../../helpers/kycFormHelper';
import { renderFormInputs } from '../../../helpers/formGeneratorHelper';
var baseClasses = getBEMClasses('kyc-form');
var slidePaneClasses = getBEMClasses('slide-pane');
var KYC_IMFormStepComponent = function (_React$Component) {
  _inherits(KYC_IMFormStepComponent, _React$Component);
  function KYC_IMFormStepComponent() {
    _classCallCheck(this, KYC_IMFormStepComponent);
    return _possibleConstructorReturn(this, (KYC_IMFormStepComponent.__proto__ || Object.getPrototypeOf(KYC_IMFormStepComponent)).apply(this, arguments));
  }
  _createClass(KYC_IMFormStepComponent, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props = this.props,
        invalid = _props.invalid,
        handleSubmit = _props.handleSubmit,
        previousPage = _props.previousPage,
        isFirst = _props.isFirst,
        level = _props.level,
        change = _props.change;
      var kycClasses = getBEMClasses('kyc-form');
      var formValues = this.props.formValues;
      setTimeout(function () {
        return setDropdownsDefaultValue(level.sections, change, formValues);
      });
      return React.createElement('form', {
        className: slidePaneClasses('body'),
        onSubmit: handleSubmit
      }, React.createElement('div', {
        className: baseClasses('form-body')
      }, React.createElement('div', {
        className: baseClasses('title')
      }, context.t(level.label)), level.sections.map(function (section, idx) {
        return React.createElement('div', {
          className: baseClasses('section'),
          key: idx
        }, React.createElement('header', {
          className: baseClasses('section-header')
        }, context.t(section.label)), React.createElement('div', {
          className: kycClasses('section-body')
        }, renderFormInputs(section.form, kycClasses(), context, change)));
      }), React.createElement('div', {
        className: baseClasses('section')
      }, !isFirst && React.createElement(APButton, {
        type: 'button',
        customClass: baseClasses('back'),
        onClick: previousPage
      }, level.prevPageLabel ? context.t(level.prevPageLabel) : context.t('Go back')), React.createElement(APButton, {
        type: 'submit',
        customClass: baseClasses(),
        disabled: invalid
      }, level.nextPageLabel ? context.t(level.nextPageLabel) : context.t('Upload your ID')))));
    }
  }]);
  return KYC_IMFormStepComponent;
}(React.Component);
KYC_IMFormStepComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default KYC_IMFormStepComponent;